import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { listLoyaltyTransactions } from './api';
import {
  LIST_LOYALTY_TRANSACTIONS_REQUEST,
  LOYALTY_TRANSACTION_REQUESTING,
  LIST_LOYALTY_TRANSACTIONS_SUCCESS,
  RESET_LOYALTY_TRANSACTION_ISFETCHING
} from './constants';

function* list(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: LOYALTY_TRANSACTION_REQUESTING });
    const response = yield call(
      listLoyaltyTransactions,
      customerId(),
      action.queryString
    );
    yield put({
      type: LIST_LOYALTY_TRANSACTIONS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_LOYALTY_TRANSACTION_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* watchList() {
  yield takeLatest(LIST_LOYALTY_TRANSACTIONS_REQUEST, list);
}

export default function* loyaltyTransactionSagas() {
  yield all([watchList()]);
}

const customerId = () => jwtDecode(Cookies.get('customerToken')).sub;
